import { CancelToken } from 'axios'

import { TableUrlParams } from 'Core/interfaces'
import { Http } from 'Core/utils/axios'

import { Manifest } from 'Portals/Customer/entities'

import { baseUrl } from './constants'

export const getList = (params: TableUrlParams): Promise<ListData<Manifest.Basic>> =>
	Http.get(baseUrl, { params })

export const retrieveManifestServiceSites = (): Promise<Entity[]> =>
	Http.get(`/service-sites/current-user`)

export const searchSuggestions = (
	{ query }: TableUrlParams,
	cancelToken?: CancelToken
): Promise<Manifest.Search.Result> => {
	const params = {
		query
	}
	return Http.get(`${baseUrl}/search-suggestions`, { params, cancelToken })
}

export const downloadManifestFile = (manifestDocumentId: Key): Promise<Blob> =>
	Http.get(`${baseUrl}/documents/${manifestDocumentId}/download`, {
		responseType: 'blob'
	})
